import kamala from '../../kamala'
import Upload from './Upload'

Upload.install = function (Vue) {
  kamala(Vue)
  Vue.component(Upload.name, Upload)
}

export default Upload
